export function initSidebar() {
    const sidebar = jQuery('.inner-order-review');
    if (sidebar.length) {
        function updateSidebarOffset() {
            const top = window.scrollY;
            const cart = jQuery('.post-content .woocommerce-cart-wrap');
            const checkout = jQuery('.post-content .woocommerce-checkout');
            let offset = cart.offset().top;

            if (top <= offset) {
                sidebar.css('top', offset - top);
            } else {
                sidebar.css('top', 0);
            }

            if (top > cart.height() + checkout.height() - sidebar.height() + offset) {
                sidebar.removeClass('sidebar-sticky');
                sidebar.addClass('sidebar-sticky-bottom');
            } else {
                sidebar.addClass('sidebar-sticky');
                sidebar.removeClass('sidebar-sticky-bottom');
            }
        }
        updateSidebarOffset();
        window.addEventListener('scroll', () => {
            updateSidebarOffset();
        });
    }
}